import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

import { Form, Nav, NavItem, Navbar } from 'react-bootstrap'

import { EXI_APP_BASE_NAME } from 'constants/Config'
import { DateRangePicker } from 'react-dates'
import React from 'react'
import find from 'lodash/find'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import remove from 'lodash/remove'

export default class SessionMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      searchValue: null,
      startDate: props.startDate && parse(props.startDate, 'yyyyMMdd', new Date()),
      endDate: props.endDate && parse(props.endDate, 'yyyyMMdd', new Date()),
      date: null,
      focused: false,
      focusedInput: true,
      beamlinesFilter: [],
    }

    this.handleSearchTermChange = this.handleSearchTermChange.bind(this)
    this.handleDatesChange = this.handleDatesChange.bind(this)
    this.handleBeamlineCheckbox = this.handleBeamlineCheckbox.bind(this)
    this.handleProposal = this.handleProposal.bind(this)
  }

  handleProposal() {}

  initBeamlines() {
    const beamlines = []
    for (const techniques in this.props.beamlines) {
      for (let i = 0; i < this.props.beamlines[techniques].length; i++) {
        beamlines.push({
          name: this.props.beamlines[techniques][i].name,
          checked: false,
        })
      }
    }
    return beamlines
  }

  handleBeamlineCheckbox(name, checked) {
    const _this = this
    if (checked) {
      if (find(this.state.beamlines, 'name') !== null) {
        this.setState(state => {
          const list = state.beamlinesFilter.concat(name)
          _this.props.filterByBeamline(list)
          return {
            beamlinesFilter: list,
          }
        })
      }
    } else {
      this.setState(state => {
        const list = remove(state.beamlinesFilter, function (n) {
          return n !== name
        })
        _this.props.filterByBeamline(list)
        return {
          beamlinesFilter: list,
        }
      })
    }
  }

  handleSearchTermChange(date) {
    this.setState({
      date: date,
    })

    const formattedDate = format(date, 'yyyyMMdd')
    this.props.fetchSessionsByDate(this.props.user, formattedDate, formattedDate)
  }

  handleDatesChange(dates) {
    this.setState({
      startDate: dates.startDate,
      endDate: dates.endDate,
    })
    if (dates.startDate && dates.endDate) {
      const startFormattedDate = format(dates.startDate, 'yyyyMMdd')
      const endFormattedDate = format(dates.endDate, 'yyyyMMdd')
      this.props.history.push('/sessions/dates/' + startFormattedDate + '/' + endFormattedDate)
      this.props.fetchSessionsByDate(this.props.user, startFormattedDate, endFormattedDate)
      this.props.setBreadCrumbs([
        { name: 'Sessions', link: EXI_APP_BASE_NAME+'/sessions' },
        { name: 'From ' + this.props.startDate + ' to ' + this.props.endDate },
      ])
    }
  }

  render() {
    return (
      <Navbar fluid>
        <Navbar.Header>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <Form inline style={{ marginTop: '5px' }}>
              <NavItem eventKey={1}>
                <DateRangePicker
                  showClearDates
                  startDate={this.state.startDate}
                  startDateId="your_unique_start_date_id"
                  endDate={this.state.endDate}
                  endDateId="your_unique_end_date_id"
                  onDatesChange={this.handleDatesChange}
                  focusedInput={this.state.focusedInput}
                  onFocusChange={focusedInput => this.setState({ focusedInput })}
                  daySize={30}
                  displayFormat="DD/MM/YYYY"
                  small
                  isOutsideRange={() => false}
                  showDefaultInputIcon
                />
              </NavItem>
            </Form>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}
